import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

export default function Divider() {
  const tailwind = useTailwind();
  return <View style={tailwind("h-1 w-full bg-red-100")} />;
}
